import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const ComponentFrameworkRetryGraphic = svgProps => {
  const baseId = "component-framework-retry-graphic";
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 208 146",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 146),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    children: [/*#__PURE__*/jsx("path", {
      d: "M208 75.2891C208 114.342 161.438 146 104 146 46.5624 146 0 114.342 0 75.2891 0 36.2365 21.6667-15.811 104 4.57816 179.833 23.3576 208 36.2365 208 75.2891Z",
      fill: `url(#${baseId}-a)`
    }), /*#__PURE__*/jsx("g", {
      filter: `url(#${baseId}-b)`,
      children: /*#__PURE__*/jsx("rect", {
        x: "21",
        y: "13",
        width: "160",
        height: "110",
        rx: "2",
        fill: "#fff"
      })
    }), /*#__PURE__*/jsx("g", {
      filter: `url(#${baseId}-c)`,
      children: /*#__PURE__*/jsx("rect", {
        x: "104.082",
        y: "56",
        width: "67",
        height: "44",
        rx: "2",
        transform: "rotate(11.91 104.082 56)",
        fill: "#E5E6E7"
      })
    }), /*#__PURE__*/jsx("g", {
      clipPath: `url(#${baseId}-d)`,
      stroke: "#989AA8",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: /*#__PURE__*/jsx("path", {
        d: "m129.357 69.3604 12.742 2.688M137.52 68.6627l-2.606-.5498c-.231-.0486-.471-.0037-.668.1249-.198.1286-.336.3303-.385.5608l-.305 1.4476 4.344.9163.305-1.4475c.049-.2304.004-.4707-.124-.668-.129-.1973-.33-.3355-.561-.3843v0ZM132.867 77.8147l.917-4.3441M135.473 78.3644l.916-4.3441M137.671 81.1691a.88113.88113 0 0 1-.395.5118c-.191.1146-.419.1524-.637.1057l-6.221-1.3121c-.218-.0455-.411-.1721-.54-.3542a.88096.88096 0 0 1-.154-.6276l1.225-9.7963 9.558 2.016-2.836 9.4567Z"
      })
    }), /*#__PURE__*/jsx("g", {
      filter: `url(#${baseId}-e)`,
      children: /*#__PURE__*/jsx("rect", {
        x: "113.805",
        y: "82.5792",
        width: "40",
        height: "10",
        rx: "1",
        transform: "rotate(11.91 113.805 82.5792)",
        fill: "#fff"
      })
    }), /*#__PURE__*/jsxs("g", {
      filter: `url(#${baseId}-f)`,
      children: [/*#__PURE__*/jsx("rect", {
        x: "29",
        y: "59.0579",
        width: "67",
        height: "44",
        rx: "2",
        transform: "rotate(-12.11 29 59.0579)",
        fill: "#F7F7F7"
      }), /*#__PURE__*/jsx("g", {
        filter: `url(#${baseId}-g)`,
        children: /*#__PURE__*/jsx("rect", {
          x: "47.724",
          y: "79.5862",
          width: "40",
          height: "10",
          rx: "1",
          transform: "rotate(-12.11 47.724 79.5862)",
          fill: "#fff"
        })
      }), /*#__PURE__*/jsx("path", {
        d: "m46.303 72.5172-4.0492-3.7131.94 4.3803-1.3884.2979-1.3995-6.5215 1.4275-.3063L45.761 70.23l-.9064-4.2239 1.3884-.2979 1.3995 6.5215-1.3395.2875Zm4.444-.9537-.5728-2.6692-3.3395-3.3131 1.5839-.3399 2.1854 2.272 1.0412-2.9644 1.5839-.3399-1.6665 4.3873.5728 2.6693-1.3884.2979Zm6.3379-2.3215.536-1.2196c.5624.3805 1.3621.6282 2.2617.4351.7626-.1636 1.0565-.6051.9768-.9767-.1049-.4888-.7077-.5333-1.4983-.5478-1.1182-.0157-2.55-.0153-2.8626-1.4721-.2329-1.0853.5169-2.1667 2.0519-2.4961 1.0364-.2224 1.964-.0942 2.7373.3637l-.5542 1.1827c-.6329-.3756-1.3852-.4494-2.0207-.313-.6257.1342-.8994.4794-.8155.8704.0944.44.6713.4594 1.462.4738 1.1279.0137 2.566.0426 2.8765 1.4896.256 1.1929-.4016 2.2749-2.1615 2.6526-1.2515.2686-2.2413.0412-2.9894-.4426Zm7.9485-.7443-1.1373-5.2994-1.9066.4092-.2622-1.2222 5.2016-1.1162.2622 1.2221-1.8968.4071 1.1372 5.2993-1.3981.3001Zm8.1209-1.7427-.652-1.0363-2.9136.6253-.1694 1.2125-1.5253.3273 1.1231-7.0629 1.7404-.3734 3.9123 5.9822-1.5155.3253Zm-3.0089-4.9182-.4433 3.2248 2.1608-.4637-1.7175-2.7611Zm8.8127 3.6727-1.7823-2.0619-1.0169.2182.5015 2.3368-1.3884.2979-1.3995-6.5215 3.0505-.6547c1.3591-.2916 2.3811.4198 2.6413 1.6322.2476 1.1537-.3438 1.925-1.0121 2.2423l1.9996 2.1687-1.5937.342Zm-.8136-4.4585c-.1175-.5476-.6135-.8093-1.1708-.6897l-1.4568.3126.386 1.799 1.4569-.3126c.5573-.1196.9022-.5618.7847-1.1093Zm4.8205 3.5986-1.1373-5.2993-1.9066.4091-.2622-1.2222 5.2015-1.1162.2623 1.2222-1.8968.407 1.1372 5.2994-1.3981.3Z",
        fill: "#000"
      })]
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("filter", {
        id: `${baseId}-b`,
        x: "11",
        y: "3",
        width: "180",
        height: "130",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {}), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0.0352941 0 0 0 0 0.0431373 0 0 0 0 0.0980392 0 0 0 0.1 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1319_5231"
        }), /*#__PURE__*/jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1319_5231",
          result: "shape"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: `${baseId}-c`,
        x: "93.3693",
        y: "56.3693",
        width: "77.9003",
        height: "60.1426",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {
          dy: "2"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: "1"
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1319_5231"
        }), /*#__PURE__*/jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1319_5231",
          result: "shape"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: `${baseId}-e`,
        x: "111.926",
        y: "82.7639",
        width: "40.8334",
        height: "18.6713",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: "1"
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: "-1",
          k3: "1"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_1319_5231"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: `${baseId}-f`,
        x: "27.3748",
        y: "45.3747",
        width: "77.9912",
        height: "60.3291",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {
          dy: "2"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: "1"
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1319_5231"
        }), /*#__PURE__*/jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1319_5231",
          result: "shape"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: `${baseId}-g`,
        x: "47.9114",
        y: "71.3807",
        width: "40.8331",
        height: "18.7955",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: "1"
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: "-1",
          k3: "1"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_1319_5231"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: `${baseId}-a`,
        x1: "104",
        y1: "0",
        x2: "104",
        y2: "146",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#ACE7D4"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#D3EDF1"
        })]
      }), /*#__PURE__*/jsx("clipPath", {
        id: `${baseId}-d`,
        children: /*#__PURE__*/jsx("path", {
          fill: "#fff",
          d: "m129.468 66.4651 13.69855 2.88958-2.88958 13.69856-13.69855-2.88959z"
        })
      })]
    })]
  });
};

export { ComponentFrameworkRetryGraphic };
//# sourceMappingURL=component-framework.retry.js.map
